import {useQuery} from "@tanstack/react-query";
import {BreederService} from "../services/breeder-service";

export const useRegisteredAnimals = (ownerId: string) => {
    const queryInfo = useQuery({
        queryKey: ['registrations', {ownerId}],
        queryFn: async () => BreederService.registeredAnimals(ownerId),
        enabled: !!ownerId,
    });

    return {
        ...queryInfo,
        registeredAnimals: queryInfo.data,
    };
};

